"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
import { TagsModel } from "../tags.model";
let CompanyModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.name = "";
  }
};
CompanyModel.model = "company.meta";
CompanyModel = __decorateClass([
  Annotation.ModelMeta
], CompanyModel);
let UserItemModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.name = "";
  }
};
UserItemModel.model = "user.item";
UserItemModel = __decorateClass([
  Annotation.ModelMeta
], UserItemModel);
let BindAccountModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.account = "";
    this.password = "";
  }
};
BindAccountModel.model = "shop.account";
BindAccountModel = __decorateClass([
  Annotation.ModelMeta
], BindAccountModel);
let GroupItemModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.name = "";
  }
};
GroupItemModel.model = "group.item";
GroupItemModel = __decorateClass([
  Annotation.ModelMeta
], GroupItemModel);
let VirtualUseragentModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.mode = "";
    this.android_ua = "";
    this.linux_ua = "";
    this.mac_ua = "";
    this.win_ua = "";
    this.unify_ua = "";
  }
};
VirtualUseragentModel.model = "virtual.useragent";
VirtualUseragentModel = __decorateClass([
  Annotation.ModelMeta
], VirtualUseragentModel);
let VirtualScreenModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.mode = "";
    this.screen = "";
  }
};
VirtualScreenModel.model = "virtual.screen";
VirtualScreenModel = __decorateClass([
  Annotation.ModelMeta
], VirtualScreenModel);
let VirtualLocaleModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.code = "";
    this.name = "";
  }
};
VirtualLocaleModel.model = "virtual.locale";
VirtualLocaleModel = __decorateClass([
  Annotation.ModelMeta
], VirtualLocaleModel);
let VirtualModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.useragent = new VirtualUseragentModel();
    this.screen = new VirtualScreenModel();
    this.locale = new VirtualLocaleModel();
    this.unify_os = false;
    this.os = new VirtualOsModel();
  }
};
VirtualModel.model = "virtual.shop";
VirtualModel = __decorateClass([
  Annotation.ModelMeta
], VirtualModel);
let VirtualOsModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.android = "";
    this.linux = "";
    this.mac = "";
    this.unify = "";
    this.windows = "";
  }
};
VirtualOsModel.model = "virtual.shop.os";
VirtualOsModel = __decorateClass([
  Annotation.ModelMeta
], VirtualOsModel);
let VirtualdesktopModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.name = "";
    this.address = "";
    this.area = "";
    this.serviceProvider = "";
    this.ip_alias = "";
  }
};
VirtualdesktopModel.model = "virtualdesktop.meta";
VirtualdesktopModel = __decorateClass([
  Annotation.ModelMeta
], VirtualdesktopModel);
let PlatformModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.name = "";
  }
};
PlatformModel.model = "platform";
PlatformModel = __decorateClass([
  Annotation.ModelMeta
], PlatformModel);
export let ShopDetailModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.name = "";
    this.company = new CompanyModel();
    this.users = new Array();
    this.account = new BindAccountModel();
    this.group = new Array();
    this.virtual = new VirtualModel();
    this.marks = new TagsModel();
    this.virtualdesktop = new VirtualdesktopModel();
    this.platform = new PlatformModel();
  }
};
ShopDetailModel.model = "shop.detail";
ShopDetailModel = __decorateClass([
  Annotation.ModelMeta
], ShopDetailModel);
export let ShopProDetailModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.oldId = "";
    this.vd = new VdDetailModel();
    this.name = "";
    this.account = null;
    this.ebusiness = new EbusinessDetailModel();
    this.authUsers = null;
    this.group = null;
    this.unifyEnv = false;
    this.shopLock = new ShopLockModel();
    this.osUserAgent = new OsUserAgentModel();
    this.resolution = new ResolutionDetail();
    this.uiLanguage = "";
    this.cookieSync = "";
    this.userAgentMode = null;
    this.browserKernelMode = null;
  }
};
ShopProDetailModel.model = "shop.detail";
ShopProDetailModel = __decorateClass([
  Annotation.ModelMeta
], ShopProDetailModel);
export let VdDetailModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.name = "";
    this.address = "";
  }
};
VdDetailModel.model = "vd.detail";
VdDetailModel = __decorateClass([
  Annotation.ModelMeta
], VdDetailModel);
export let EbusinessDetailModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.name = "";
  }
};
EbusinessDetailModel.model = "ebusiness.detail";
EbusinessDetailModel = __decorateClass([
  Annotation.ModelMeta
], EbusinessDetailModel);
export let OsUserAgentModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.windows = null;
    this.mac = null;
    this.android = null;
    this.linux = null;
    this.unify = null;
  }
};
OsUserAgentModel.model = "useragent";
OsUserAgentModel = __decorateClass([
  Annotation.ModelMeta
], OsUserAgentModel);
export let UserAgentModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.osCode = "";
    this.osName = "";
    this.userAgent = "";
  }
};
UserAgentModel.model = "useragent.detail";
UserAgentModel = __decorateClass([
  Annotation.ModelMeta
], UserAgentModel);
export let ResolutionDetail = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.mode = "";
    this.screen = null;
  }
};
ResolutionDetail.model = "resolution";
ResolutionDetail = __decorateClass([
  Annotation.ModelMeta
], ResolutionDetail);
export let ShopLockModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.lock = false;
    this.lockNum = 0;
  }
};
ShopLockModel.model = "shop.lock";
ShopLockModel = __decorateClass([
  Annotation.ModelMeta
], ShopLockModel);
